import React from "react";
import Select from "react-select";
import CustomizedOption from "./CustomizedOption";
import Helpers from "../../services/helpers";
import MultiSelectField from "./MultiSelectField";
import DB from '../../services/db.jsx';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.entity;
  }

  updateField(e, key) {
    this.setState({ [key]: e.target.value });
    if (this.props.afterChange) {
      this.props.afterChange(key, e.target.value);
    }
  }

  updateFieldVal(val, key) {
    this.setState({ [key]: val });
    if (this.props.afterChange) {
      this.props.afterChange(key, val);
    }
  }

  updateBoolean(value, key) {
    this.setState({ [key]: value });
    if (this.props.afterChange) {
      this.props.afterChange(key, value);
    }
  }

  updatePassword(e, key) {
    this.setState({ [key]: e.target.value });

    if (!this.props.fields[key]?.disabledValidation) {
      if (!Helpers.isValidPassword(e.target.value)) {
        this.props.fields[key].error = true;
      } else {
        this.props.fields[key].error = false;
      }
    }

    if (this.props.afterChange) {
      this.props.afterChange(key, e.target.value);
    }
  }

  onCancel(e, callback) {
    e.preventDefault();
    callback();
  }

  onSubmit(e, callback) {
    e.preventDefault();
    callback();
  }

  render() {
    return (
      <form
        onSubmit={(e) => this.onSubmit(e, () => this.props.save(this.state))}
      >
        <div className="actions clearfix">
          <div className="buttons clearfix">
            {!this.props.hideCancel && (
              <div
                className="button grey"
                onClick={(e) => this.onCancel(e, () => this.props.cancel())}
              >
                {this.props.cancelText || "Cancel"}
              </div>
            )}
            {this.props.canDelete && (
              <div
                className="button red"
                onClick={(e) => this.onCancel(e, () => this.props.delete())}
              >
                {this.props.deleteText || "Delete"}
              </div>
            )}
            {
              !this.props.hideSave && (
                <button className="blue">{this.props.saveText || "Save"}</button>
              )
            }
          </div>
        </div>

        <div className="block">
          <div className="fields clearfix">
            {!this.props.hideTitle && <h2>{this.props.title || "Detail"}</h2>}
            {Object.keys(this.props.fields).map((field) => {
              return (
                <div
                  className={`field${
                    this.props.fields[field]?.fullWidth ? ' full' : ''
                  }${(this.props.disabled || this.props.fields[field]?.disabled) ? ' disabled' : ''}`}
                  key={field}
                  style={{
                    display:
                      this.props.fields[field]?.hidden ? 'none'
                        : 'block',
                  }}
                >
                  <label>{this.props.fields[field].label}
                    {this.props.fields[field].tooltip && (
                      <div className="icon">
                        <div className="tooltip">
                          <div className="content"
                            dangerouslySetInnerHTML={{
                              __html: String(this.props.fields[field].tooltip).replace(/\n/g, '<br>')
                            }}
                          />
                        </div>
                        <i className="icon-warning" />
                      </div>
                    )}
                  </label>
                  {this.props.fields[field].type === 'text' && (
                    <input
                      type='text'
                      placeholder={this.props.fields[field].placeholder}
                      onChange={(e) => this.updateField(e, field)}
                      required={this.props.fields[field].required}
                      value={this.state[field]}
                      disabled={this.props.disabled || this.props.fields[field]?.disabled}
                    />
                  )}
                  {this.props.fields[field].type === 'email' && (
                    <input
                      type='email'
                      onChange={(e) => this.updateField(e, field)}
                      required={this.props.fields[field].required}
                      value={this.state[field]}
                      disabled={this.props.disabled || this.props.fields[field]?.disabled}
                    />
                  )}
                  {this.props.fields[field].type === 'select' && (
                    <Select
                      className={`default-selector ${
                        this.props?.fields[field]?.className || ''
                      }`}
                      classNamePrefix='default-selector'
                      placeholder={this.props.field?.[field]?.placeholder}
                      required={this.props.fields[field].required}
                      value={
                        this.state[field]
                          ? this.props?.fields[field]?.options?.find(
                              (i) => i.key === this.state[field]
                            )
                          : null
                      }
                      options={this.props.fields[field].options}
                      getOptionLabel={(entity) => entity.label}
                      getOptionValue={(entity) => entity.key}
                      onChange={(e) => {
                        if (e.key) {
                          this.updateFieldVal(e.key, field);
                        }
                      }}
                      styles={{
                        menu: (base) => ({
                          ...base,
                          width: 204,
                        }),
                      }}
                      isDisabled={this.props.disabled || this.props.fields[field]?.disabled}
                      components={{
                        Option: CustomizedOption,
                        IndicatorsContainer: (state) => {
                          const { selectProps } = state;
                          return (
                            <div className='default-selector__indicator'>
                              <i
                                className={`icon-carot-${
                                  selectProps?.menuIsOpen ? 'up' : 'down'
                                } ${
                                  selectProps?.menuIsOpen ? 'menu-opened' : ''
                                }`}
                              />
                            </div>
                          );
                        },
                      }}
                    />
                  )}
                  {this.props.fields[field].type === 'select-multi' && (
                    <MultiSelectField
                      value={this.state[field]}
                      onChange={(val) => this.updateFieldVal(val, field)}
                      optionKey={this.props.fields[field].optionKey}
                      options={this.props.fields[field].options}
                      className={this.props.fields[field]?.className}
                      classNamePrefix='default-selector'
                      placeholder={this.props.field?.[field]?.placeholder}
                      required={this.props.fields[field].required}
                      disabled={this.props.disabled || this.props.fields[field]?.disabled}
                    />
                  )}
                  {this.props.fields[field].type === 'boolean' && (
                    <div className='radio'>
                      {console.log(this.props.fields[field])}
                      <input
                        type='radio'
                        name={field}
                        onChange={(e) => this.updateBoolean(true, field)}
                        checked={this.state[field] === true ? true : false}
                        disabled={this.props.disabled || this.props.fields[field]?.disabled}
                      />
                      <span>Yes</span>
                      <input
                        type='radio'
                        name={field}
                        onChange={(e) => this.updateBoolean(false, field)}
                        checked={this.state[field] === false ? true : false}
                        disabled={this.props.disabled || this.props.fields[field]?.disabled}
                      />
                      <span>No</span>
                    </div>
                  )}
                  {this.props.fields[field].type === 'checkbox-list' && (
                    <div className='checkbox-list'>
                      {this.props.fields[field].list?.map(
                        (listItem, listIndex) => {
                          listItem.options = listItem.options || [];

                          return (
                            <div
                              className='checkbox-list__group'
                              key={listIndex}
                            >
                              {listItem.options.map((option, index) => (
                                <div
                                  className='checkbox'
                                  key={index}
                                  onClick={() => {
                                    if (this.props.disabled || this.props.fields[field]?.disabled) return;
                                    const newState = { ...this.state };
                                    if (newState[field].includes(option.key)) {
                                      newState[field] = newState[field].filter(
                                        (i) => i !== option.key
                                      );
                                    } else {
                                      newState[field].push(option.key);
                                    }
                                    this.updateFieldVal(newState[field], field);
                                  }}
                                >
                                  <input
                                    type='checkbox'
                                    checked={this.state[field].includes(
                                      option.key
                                    )}
                                    onChange={() => {}}
                                    disabled={this.props.disabled || this.props.fields[field]?.disabled}
                                  />
                                  <span></span>
                                  <label>{option.label}</label>
                                </div>
                              ))}
                            </div>
                          );
                        }
                      )}
                    </div>
                  )}
                  {this.props.fields[field].type === 'password' && (
                    <input
                      type='password'
                      placeholder={this.props.fields[field].placeholder}
                      onChange={(e) => this.updatePassword(e, field)}
                      required={this.props.fields[field].required}
                      value={this.state[field]}
                      disabled={this.props.disabled || this.props.fields[field]?.disabled}
                    />
                  )}

                  {this.props.fields[field].error && (
                    <label className='error'>
                      {this.props.fields[field].errorMessage || 'Error'}
                    </label>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </form>
    );
  }
}

export default Form;
